import script from "./analysis-card.vue?vue&type=script&setup=true&lang=js"
export * from "./analysis-card.vue?vue&type=script&setup=true&lang=js"

import "./analysis-card.vue?vue&type=style&index=0&id=0c2a4806&lang=less&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2a4806"]])

export default __exports__